import { useConfig } from "./ConfigContext";
import dayjs from "dayjs";

const useFormattingUtils = () => {
  const { config } = useConfig(); 

  const formatDate = (date) => {
    if (!date) return "";
    const dateObj = typeof date === "string" ? new Date(date) : date;
      return dayjs(dateObj).format(config.dateFormat);

  };

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return "";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: config.currency || "USD",
    }).format(amount);
  };

  return {
    dateFormat: config.dateFormat,
    formatDate,
    currency: config.currency,
    formatCurrency,
  };
};

export default useFormattingUtils;
